import React, { createContext, useContext, useState, useEffect } from 'react';

const HeaderContext = createContext({ header: null, setHeader: () => {} });

export function HeaderProvider({ children }) {
  const [header, setHeader] = useState(null);
  return (
    <HeaderContext.Provider value={{ header, setHeader }}>
      {children}
    </HeaderContext.Provider>
  );
}

export function useHeaderContext() {
  return useContext(HeaderContext);
}

// Lets a page publish its title/subtitle/actions into the shell header
// while it's mounted. `deps` follows the same contract as useEffect's.
export function usePageHeader(header, deps) {
  const { setHeader } = useHeaderContext();
  // `deps` lo controla cada página que llama a este hook (mismo contrato que el
  // segundo argumento de useEffect) — por diseño no es un array literal, así que
  // exhaustive-deps no puede verificarlo estáticamente. `setHeader` es estable
  // (viene de useState) y `header` se pasa explícitamente en el propio efecto,
  // no hace falta declararlos aparte.
  useEffect(() => {
    setHeader(header);
    return () => setHeader(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
